import axios from "axios"
import secureLocalStorage from "react-secure-storage"
import { BASE_URL, PARTNER_INSIGHTS_API } from "@utils/constants.util"
import { StorageKeys } from "@utils/user-config"

let mainApiToken: string | null = null
let insightsApiToken: string | null = null

export const getMainApiCsrfToken = (): string | null => mainApiToken
export const getInsightsApiCsrfToken = (): string | null => insightsApiToken

// The csrf-token endpoint is authenticated, so the requests must carry the
// same credentials the rest of the app uses (bearer token + id token).
const buildAuthHeaders = (): Record<string, string> => {
	const headers: Record<string, string> = {}
	const token = secureLocalStorage.getItem(StorageKeys.USER_TOKEN) as string
	const idToken = secureLocalStorage.getItem(
		StorageKeys.USER_ID_TOKEN
	) as string

	if (token) {
		headers.Authorization = `Bearer ${token}`
	}
	if (idToken) {
		headers["X-Id-Token"] = idToken
	}
	return headers
}

export const initializeCsrf = async (): Promise<void> => {
	const authHeaders = buildAuthHeaders()
	const [mainResult, insightsResult] = await Promise.allSettled([
		axios.get<{ data: { csrfToken: string } }>(`${BASE_URL}/csrf-token`, {
			withCredentials: true,
			headers: authHeaders
		}),
		axios.get<{ data: { csrfToken: string } }>(
			`${PARTNER_INSIGHTS_API}/csrf-token`,
			{
				withCredentials: true,
				headers: authHeaders
			}
		)
	])

	if (mainResult.status === "fulfilled") {
		mainApiToken = mainResult.value.data.data.csrfToken
	} else {
		console.error("[CSRF] Failed to fetch main API token:", mainResult.reason)
	}

	if (insightsResult.status === "fulfilled") {
		insightsApiToken = insightsResult.value.data.data.csrfToken
	} else {
		console.error(
			"[CSRF] Failed to fetch insights API token:",
			insightsResult.reason
		)
	}
}

export const ensureMainApiCsrfToken = async (): Promise<string | null> => {
	if (!mainApiToken) {
		await initializeCsrf()
	}
	return mainApiToken
}

export const ensureInsightsApiCsrfToken = async (): Promise<string | null> => {
	if (!insightsApiToken) {
		await initializeCsrf()
	}
	return insightsApiToken
}
